module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.invoice) ? _c('div', {
    staticClass: "thankyou-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "text-center text-primary "
  }, [_vm._v("ขอบคุณสำหรับการบริจาค")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showBankTransferInfo) ? _c('div', {
    staticClass: "text-center thankyou-remark"
  }, [_c('h3', [_vm._v("ช่องทางการโอนเงิน")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), (_vm.showBankTransferInfo) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.showUploadSlipForm) ? _c('div', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (!_vm.showUploadSlipForm) ? _c('div', [_vm._m(3)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showChequeInfo) ? _c('div', {
    staticClass: "show-note"
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.showUploadSlipForm) ? _c('div', {
    staticClass: "show-uploadslip"
  }, [_c('upload-slip')], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("และร่วมเป็นส่วนหนึ่งในการช่วยแก้ปัญหา"), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("ความเหลื่อมล้ำทางการศึกษาไทย")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": "/static/img/thaibank/ktb.png",
      "height": "20"
    }
  }), _vm._v("ธนาคารกรุงไทย"), _c('br'), _vm._v(" สาขา ซอยอารีย์ (ออมทรัพย์) "), _c('br'), _vm._v("ชื่อบัญชี: กสศ.มาตรา 6(6) - เงินบริจาค"), _c('br'), _vm._v("เลขบัญชี 172-0-30021-6")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center thankyou-remark bg-light"
  }, [_c('p', [_vm._v("กรุณายืนยันการโอนเงิน จากแบบฟอร์มด้านล่าง"), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้")]), _vm._v(" "), _c('p', [_vm._v("ผู้บริจาคต้องแนบหลักฐานการโอนเงินภายใน 3 วันหลังจากทำรายการสำเร็จ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center thankyou-remark"
  }, [_c('p', [_vm._v("อีกสักครู่ คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "block-primary block shadow radius mb-15 mt-15"
  }, [_c('h2', {
    staticClass: "text-center mb-20"
  }, [_vm._v("การบริจาคผ่านเช็คสั่งจ่าย")]), _vm._v(" "), _c('div', {
    staticClass: "form__item pd-15"
  }, [_c('div', {
    staticClass: "show-note-item"
  }, [_c('strong', [_vm._v("1. เช็คสั่งจ่าย")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("มูลนิธิยุวพัฒน์ เพื่อโครงการร้อยพลังการศึกษา")])]), _vm._v(" "), _c('div', {
    staticClass: "show-note-item"
  }, [_c('strong', [_vm._v("2. จัดส่งเช็คตัวจริงมาตามที่อยู่ด้านล่างนี้")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("\n                ฝ่ายบัญชี"), _c('br'), _vm._v("\n                มูลนิธิยุวพัฒน์"), _c('br'), _vm._v("\n                1 อาคารพรีเมียร์คอร์เปอเรทปาร์ค ถนนศรีนครินทร์ แขวงหนองบอน เขตประเวศ กรุงเทพ 10250\n              ")])])]), _vm._v(" "), _c('p', {
    staticClass: "mw-600"
  }, [_vm._v("เมื่อเจ้าหน้าที่ตรวจสอบความถูกต้องแล้ว ผู้บริจาคจะได้รับอีเมลยืนยันอีกครั้ง จึงจะถือว่าการบริจาค\nเสร็จสมบูรณ์")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8422737a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8422737a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/thank-you/base.vue
// module id = 757
// module chunks = 1